<mat-toolbar>
    <div class="md-toolbar-tools">
        <h1 mat-dialog-title class="subtitle">Rematrícula</h1>
        <span flex></span>
        <div class="posicionar-direita">
            <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado">
                <mat-icon>fullscreen_exit</mat-icon>
            </button>
            <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado">
                <mat-icon>fullscreen</mat-icon>
            </button>
            <button (click)="fecharDialog()" class="botao-header">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</mat-toolbar>
<mat-dialog-content>
  <mat-stepper [linear]="true" orientation="vertical" #stepper (selectionChange)="onStepChange($event)">
    <form [formGroup]="preMatriculaForm">
      <mat-step [completed]="dadosMatriculaPreenchidos">
          <ng-template matStepLabel>Dados da Matrícula</ng-template>

          <div class="row">
            <mat-form-field  class="col-md-6 col-xs-12">
              <mat-label>Turmas</mat-label>
              <mat-select (selectionChange)="determinaTurma()" formControlName="turmaSelecionada" panelClass="custom-select-panel">
                @for (turma of turmas; track turma) {
                  <mat-option [value]="turma">{{turma.descricao}}</mat-option>
                }
              </mat-select>
              <mat-error>Selecione uma turma.</mat-error>
            </mat-form-field>

            <mat-form-field class="col-md-6 col-xs-12">
              <mat-label>Modalidade</mat-label>
              <mat-select formControlName="turmaPrecoSelecionado" panelClass="custom-select-panel">
                @for (turmaPreco of turmaPrecos; track turmaPreco) {
                  <mat-option [value]="turmaPreco">{{turmaPreco.descricao}}</mat-option>
                }
              </mat-select>
              <mat-error>
                @if (!this.preMatriculaForm.get('turmaSelecionada')?.value) {
                  Selecione uma turma primeiro.
                } @else {
                  Selecione uma modalidade.
                }
              </mat-error>
            </mat-form-field>
          </div>

          <div class="button-row">
            <button mat-raised-button color="primary" type="submit" matStepperNext>Próximo</button>
          </div>


      </mat-step>

      <!-- Mensalidade -->
      <!-- Não exibe step se não houver condições de pagamento ativas para a mensalidade -->
      @if (verificaCobrancaHabilitada(1) && verificaCondicaoPagamentoModalidade(1) && turmaPreco.valorMensalidade > 0) {

        <mat-step [completed]="pagamentoMensalidadeSelecionado">
          <ng-template matStepLabel>Mensalidade</ng-template>

          <h3>Como desejará pagar a mensalidade? (pago posteriormente)</h3>

          <div class="col-md-12 col-xs-12 pagamento-group">
            <mat-radio-group class="custom-radio-group">
              @for (mensalidadeTurmaPrecoCondicaoPagamento of mensalidadeTurmaPrecoCondicaoPagamentos; track mensalidadeTurmaPrecoCondicaoPagamento) {
                <mat-radio-button (change)="calculaPagamentoValores($event)" [value]="mensalidadeTurmaPrecoCondicaoPagamento">
                  <span>
                    {{textoContaParcelaTipoPagamento(mensalidadeTurmaPrecoCondicaoPagamento.contaParcelaTipoPagamento)}}
                    -
                    {{mensalidadeTurmaPrecoCondicaoPagamento.indicadorPagamento == 0 ? 'À vista': 'A prazo'}}
                    <div class="wrap-mat-radio-label">
                    @if (mensalidadeTurmaPrecoCondicaoPagamento.desconto > 0) {
                        {{'Desconto de: ' + mensalidadeTurmaPrecoCondicaoPagamento.desconto + '%'}}
                      }
                    </div>
                    {{'Em até ' + mensalidadeTurmaPrecoCondicaoPagamento.parcelasMaximas + ' parcela(s)'}}
                  </span>
                </mat-radio-button>
              }
            </mat-radio-group>

            </div>


          <div class="button-row">
            <button mat-raised-button color="accent" matStepperPrevious>Voltar</button>
            <button mat-raised-button color="primary" matStepperNext>Próximo</button>
          </div>

        </mat-step>
      }

      <!-- Material Didático -->
       <!-- Não exibe step se não houver condições de pagamento ativas para o material didático -->
      @if(verificaCobrancaHabilitada(2) && verificaCondicaoPagamentoModalidade(2) && turmaPreco.valorMaterialDidatico > 0) {
        <mat-step [completed]="pagamentoMaterialDidaticoSelecionado">
          <ng-template matStepLabel>Material Didático</ng-template>
          <h3>Como desejará pagar o material didático? (pago posteriormente)</h3>

          <div class="col-md-12 col-xs-12 pagamento-group">
            <mat-radio-group class="custom-radio-group">
              @for (materialDidaticoTurmaPrecoCondicaoPagamento of materialDidaticoTurmaPrecoCondicaoPagamentos; track materialDidaticoTurmaPrecoCondicaoPagamento) {
                <mat-radio-button (change)="calculaPagamentoValores($event)" [value]="materialDidaticoTurmaPrecoCondicaoPagamento">
                  <span>
                    {{textoContaParcelaTipoPagamento(materialDidaticoTurmaPrecoCondicaoPagamento.contaParcelaTipoPagamento)}}
                    -
                    {{materialDidaticoTurmaPrecoCondicaoPagamento.indicadorPagamento == 0 ? 'À vista': 'A prazo'}}
                    <div class="wrap-mat-radio-label">
                    @if (materialDidaticoTurmaPrecoCondicaoPagamento.desconto > 0) {
                        {{'Desconto de: ' + materialDidaticoTurmaPrecoCondicaoPagamento.desconto + '%'}}
                      }
                    </div>
                    {{'Em até ' + materialDidaticoTurmaPrecoCondicaoPagamento.parcelasMaximas + ' parcela(s)'}}
                  </span>
                </mat-radio-button>
              }
            </mat-radio-group>
            @if(turmaPreco.valorMaterialDidatico === 0 && verificaCondicaoPagamentoModalidade(2)) {

              <app-status-card
                texto="Valores ainda a serem definidos pela instituição"
                cor="azul"
                icone="request_quote"
                backgroundColor="#f5f9ff"
                >
              </app-status-card>

            } @else {
              <app-status-card
                texto="Valor Material Didático Final: {{ (qtdeParcelasMaterialDidaticoSelecionada) + 'x ' + (materialDidaticoFinalParcela | currency) }}"
                cor="azul"
                icone="request_quote"
                backgroundColor="#f5f9ff"
                [descricao]="
                'Valor Material Didático: ' + (qtdeParcelasMaterialDidaticoSelecionada) + 'x ' + (materialDidaticoParcela | currency) +
                '<br>Desconto Forma de Pagamento Escolhida: ' +
                (descontoMaterialDidatico | currency) +
                '(' + percentualDescontoMaterialDidatico + ')'">
              </app-status-card>
            }
          </div>

          <div class="button-row">
            <button mat-raised-button matStepperPrevious color="accent">Voltar</button>
            <button mat-raised-button matStepperNext color="primary">Próximo</button>
          </div>
        </mat-step>
      }

      <mat-step #stepMatricula [completed]="pagamentoMatriculaSelecionado">
        <ng-template matStepLabel>Matrícula</ng-template>
          @if(verificaCobrancaHabilitada(0) && verificaCondicaoPagamentoModalidade(0) && turmaPreco.valorMatricula > 0) {
            <h3>Como deseja pagar a matrícula? (pago agora) - {{turmaPreco.valorMatricula | currency}}</h3>

            <div class="col-md-12 col-xs-12 pagamento-group">
              <mat-radio-group class="custom-radio-group">
                @for (matriculaTurmaPrecoCondicaoPagamento of matriculaTurmaPrecoCondicaoPagamentos; track matriculaTurmaPrecoCondicaoPagamento) {
                  <mat-radio-button (change)="calculaPagamentoValores($event)" [value]="matriculaTurmaPrecoCondicaoPagamento">
                    <span>
                      {{textoContaParcelaTipoPagamento(matriculaTurmaPrecoCondicaoPagamento.contaParcelaTipoPagamento)}}
                      -
                      {{matriculaTurmaPrecoCondicaoPagamento.indicadorPagamento == 0 ? 'À vista': 'A prazo'}}
                      <div class="wrap-mat-radio-label">
                      @if (matriculaTurmaPrecoCondicaoPagamento.desconto > 0) {
                          {{'Desconto de: ' + matriculaTurmaPrecoCondicaoPagamento.desconto + '%'}}
                        }
                      </div>
                      {{'Em até ' + matriculaTurmaPrecoCondicaoPagamento.parcelasMaximas + ' parcela(s)'}}
                    </span>
                  </mat-radio-button>
                }
              </mat-radio-group>
              <app-status-card
                texto="Valor Matrícula Final:  {{ (qtdeParcelasMatriculaSelecionada) + 'x ' + (matriculaFinalParcela | currency) }}"
                cor="azul"
                icone="request_quote"
                backgroundColor="#f5f9ff"
                [descricao]="
                'Valor Matrícula : ' + (qtdeParcelasMatriculaSelecionada) + 'x ' + (matriculaParcela | currency) +
                '<br>Desconto Forma de Pagamento Escolhida: ' +
                (descontoMatricula | currency) +
                '(' + percentualDescontoMatricula + ')'">
              </app-status-card>
            </div>

            <br>
            <h3>Dados do Pagador</h3>
            <div class="row">
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>CPF do {{titularTexto}}</mat-label>
                <input appRequiredField type="text" matInput placeholder="CPF" formControlName="pagadorCpf">
              </mat-form-field>

              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Nome do {{titularTexto}}</mat-label>
                <input required type="text" matInput formControlName="pagadorNome">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>E-mail do {{titularTexto}}</mat-label>
                <input required type="email" matInput placeholder="E-mail" formControlName="pagadorEmail">
              </mat-form-field>
            </div>

            <div class="row rowmaterial">
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Telefone do {{titularTexto}}</mat-label>
                <input required type="text" matInput formControlName="pagadorTelefone">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Cep do {{titularTexto}}</mat-label>
                <input appRequiredField type="text" matInput placeholder="Cep" formControlName="pagadorCep">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>País do {{titularTexto}}</mat-label>
                <mat-select required formControlName="paisSelecionado" panelClass="custom-select-panel">
                  @for (pais of paises; track pais) {
                    <mat-option [value]="pais">{{pais.descPais}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="row rowmaterial">
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Logradouro do {{titularTexto}}</mat-label>
                <input required type="text" matInput placeholder="Logradouro"
                    formControlName="pagadorLogradouro">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Número do Endereço do {{titularTexto}}</mat-label>
                <input type="text" matInput placeholder="Número"
                    formControlName="pagadorLogradouroNumero">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Complemento do Endereço do {{titularTexto}}</mat-label>
                <input type="text" matInput placeholder="Complemento"
                    formControlName="pagadorLogradouroComplemento">
              </mat-form-field>
            </div>

            <div class="row rowmaterial">
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Bairro do {{titularTexto}}</mat-label>
                <input required type="text" matInput placeholder="Bairro" formControlName="pagadorBairro">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>UF do {{titularTexto}}</mat-label>
                <mat-select formControlName="ufSelecionada" panelClass="custom-select-panel">
                  @for (uf of ufs; track uf) {
                    <mat-option [value]="uf">{{uf.siglaUF}} - {{uf.descUF}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field class="col-md-4 col-xs-12 form-group">
                <mat-label>Município do {{titularTexto}}</mat-label>
                <mat-select formControlName="municipioSelecionado" panelClass="custom-select-panel">
                  @for (municipio of municipios; track municipio) {
                    <mat-option [value]="municipio">{{municipio?.descricao}}</mat-option>
                  }
                </mat-select>
                <mat-error>Escolha uma UF</mat-error>
              </mat-form-field>
            </div>

            <hr>
          }

        <mat-checkbox formControlName="ciente">
          Estou ciente de que esta pré-matrícula somente será efetivada após o pagamento da matrícula,
          o qual será gerado na próxima etapa deste formulário. Também estou ciente de que se trata de
          uma reserva de vaga condicionada à confirmação da instituição, que verificará a adimplência
          do contrato do ano vigente e eventuais pendências administrativas ou acadêmicas (se aplicável).
        </mat-checkbox>

          <div class="button-row">
            <button mat-raised-button color="accent" matStepperPrevious>Voltar</button>
            <button mat-raised-button color="primary" [disabled]="isLoading || preMatriculaForm.invalid" (click)="salvarPreMatricula()">Próximo</button>
            <button class="pay-button-getnet" #getNetButton id="getNetButton" type="button"
                        style="display: none;"></button>
          </div>
        </mat-step>

    </form>
    <!-- <mat-step>
      <ng-template matStepLabel>Finalizar</ng-template>

      <div class="button-row">
        <button mat-raised-button color="accent" matStepperPrevious>Voltar</button>
        <button mat-raised-button color="primary" (click)="salvarPreMatricula()">Finalizar</button>
      </div>
    </mat-step> -->
  </mat-stepper>
</mat-dialog-content>
